<template>
  <div>
    <advertisement-top-banner-text />
    <template v-if="$options.components['advertisement-loading']">
      <advertisement-loading v-if="isLoading" />
    </template>
    <div
      else
      :style="{ display: cartData.length != 0 ? '' : 'none' }"
      class="checkout"
    >
      <b-container>
        <b-row>
          <b-col md="8">
            <template v-if="!activatePaymentKey">
              <template v-if="$options.components['checkout-order-summary']">
                <checkout-order-summary
                  :loadingItem="loadingItem"
                  :cartData="$store.state['checkout'].cartData"
                  :showSellerDetails="selfPickSelected"
                />
              </template>
            </template>
            <!-- coupon code -->
            <!-- <template v-if="$options.components['checkout-cart-coupon']">
							<div class="mb-4">
								<checkout-cart-coupon :callApi="false" />
							</div>
						</template> -->
            <!-- // -->
            <template v-if="activatePaymentKey">
              <b-icon
                icon="arrow-left"
                scale="2"
                class="ml-1 mb-2 direct-class"
                variant="dark"
                @click="toCheckout"
              />
            </template>
            <template>
              <div class="store-box py-3">
                <b-form-radio-group
                  @change="changeDeliveryMode"
                  class="mt-2 ml-3"
                  v-model="selectedDeliveryMode"
                >
                  <b-row>
                    <b-col class="p-0" md="6" v-if="selfPickupEnabled">
                      <b-form-radio value="pickup" name="radio-size" size="lg">
                        <h5>{{ $t("cart.selfPickup") }}</h5>
                      </b-form-radio>
                    </b-col>
                    <b-col class="p-0" md="6" v-if="deliveryEnabled">
                      <b-form-radio
                        value="delivery"
                        name="radio-size"
                        size="lg"
                      >
                        <h5>
                          {{ $t("cart.deliverAddress") }}
                        </h5>
                      </b-form-radio>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </div>
            </template>
            <template v-if="selfPickSelected">
              <b-row class="mt-3">
                <b-col>
                  <b-form-datepicker
                    :placeholder="$t('cart.pickupDate')"
                    id="date-time"
                    v-model="date"
                    class="mb-2"
                    :min="minDate"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="en"
                    @input="changeDate"
                  ></b-form-datepicker>
                </b-col>
                <b-col>
                  <b-form-select
                    class="time-picker"
                    v-model="selectedTimeSlot"
                    :options="timeSlots"
                    @change="changeTimeSlot"
                  ></b-form-select>
                </b-col>
              </b-row>
            </template>
            <template
              v-if="
                $options.components['address-cart-address'] &&
                selectedDeliveryMode !== 'pickup'
              "
            >
              <div class="store-box">
                <address-cart-address :callApi="false" />
              </div>
            </template>
            <!-- <template v-if="selfPickSelected">
							<div class="store-box">
								<h4>{{ $t("cart.selectStore") }}</h4>
								<p
									class="no-delivery-p-tag text-center"
									v-if="!storeAddressList.length"
								>
									{{ $t("cart.noStoreAvailable") }}
								</p>
								<b-form-radio-group
									@change="changeAddress"
									class="mt-2 ml-3"
									v-model="selectedAddress"
								>
									<div
										v-for="item in storeAddressList"
										:key="item.value"
									>
										<div class="store-select">
											<b-form-radio
												:value="item.value"
												class="radio-option"
												name="radio-size"
												size="lg"
											>
												<h6>
													{{ item.text }}
												</h6>
											</b-form-radio>
											<div
												class="d-flex align-items-center justify-content-start direct-class"
												@click="
													navigateToGoogleMap(item.value)
												"
											>
												<h4>
													{{ $t("cart.direction") }}
													<b-iconstack class="ml-3">
														<b-icon
															scale="1.8"
															stacked
															icon="circle-fill"
															variant="dark"
														></b-icon>
														<b-icon
															icon="arrow90deg-right"
															scale="1"
															class="cart-icon"
															variant="primary"
														></b-icon>
													</b-iconstack>
												</h4>
											</div>
										</div>
									</div>
								</b-form-radio-group>
							</div>
						</template> -->
            <template v-if="activatePaymentKey">
              <template v-if="$options.components['checkout-cart-payment']">
                <checkout-cart-payment @changePaymentSelect="onPaymentSelect" />
              </template>
            </template>
            <template>
              <div id="payment-div" class="mt-3"></div>
            </template>
          </b-col>

          <b-col md="4">
            <template v-if="$options.components['checkout-price-card']">
              <checkout-price-card :activatePaymentKey="activatePaymentKey" />
            </template>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row class="mt-5 mb-3">
          <b-col class="text-center">
            <template v-if="!activatePaymentKey">
              <button
                @click="() => this.clearCart()"
                type="button"
                class="btn btn-outline-primary btn-lg mr-3 mb-2"
              >
                <span class="button-text"></span>
                {{ $t("cart.clearCart") }}
              </button>
              <button
                :disabled="!(checkoutLoading == false)"
                @click="continuePayment"
                type="button"
                class="btn btn-primary btn-lg mr-3 mb-2"
              >
                <span class="button-text"></span>
                {{ $t("cart.continue") }}
              </button>
            </template>
            <template v-if="activatePaymentKey">
              <template v-if="checkoutLoading === true">
                <b-spinner
                  v-for="i in 3"
                  :key="i"
                  class="mr-1"
                  small
                  label="Small Spinner"
                  type="grow"
                ></b-spinner>
              </template>
              <div
                v-if="
                  !checkoutLoading &&
                  checkoutLoading !== 'errorAddress' &&
                  !onlinePaymentLoaded
                "
                class="place-order-btn-box"
              >
                <button
                  @click="returnToCheckout"
                  type="button"
                  class="btn btn-outline-primary btn-lg"
                >
                  <span class="button-text"></span>
                  {{ $t("cart.back") }}
                </button>
                <button
                  @click="placeOrderInit"
                  type="button"
                  class="btn btn-primary btn-lg"
                >
                  <span class="button-text"></span>
                  {{ $t("cart.placeOrder") }}
                </button>
              </div>
            </template>
          </b-col>
        </b-row>
      </b-container>
      <b-modal
        id="bv-add-address"
        size="lg"
        :hide-footer="true"
        :hide-header="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        centered
        header-class="my-class"
        body-class="p-0"
      >
        <template v-if="$options.components['address-add-address-modal']">
          <address-add-address-modal />
        </template>
      </b-modal>
    </div>
    <div>
      <div
        :style="{ display: cartData.length == 0 ? '' : 'none' }"
        class="text-center checkout-empty"
      >
        <b-img inline src="img/icon-empty-cart.png" fluid></b-img>
        <h3 class="font-weight-bold mb-4 mt-4">
          {{ $t("checkout.cartEmpty") }}!
        </h3>
        <b-button @click="$router.push('/')" class="mb-2 w-auto button-color">{{
          $t("wishlistProduct.continueShopping")
        }}</b-button>
      </div>
    </div>
    <VueCashfree
      :initialiseKey="initialiseKey"
      @onSuccess="onSuccess"
      @onFailure="onFailure"
      :orderToken="orderToken"
      :env="cashfreeEnv"
    />
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { mapState } from "vuex";
// import Vue from "vue";
import VueCashfree from "vue-cashfree-sdk";
export default {
  name: "checkout",
  components: {
    VueCashfree,
  },
  computed: {
    ...mapState({
      allowPickupFromShop: (state) => state.checkout.allowPickupFromShop,
      checkoutData: (state) => state.checkout.checkoutData,
      partnerInfo: (state) => state.checkout.partnerInfo,
      cartData: (state) => state.checkout.cartData,
      defaultAddress: (state) => state.address.defaultAddress,
      userInfo: (state) => state.auth.userInfo,
      paymentMethodClick: (state) => state.checkout.paymentMethodClick,
      createdOrderData: (state) => state.checkout.createdOrderData,
      storeList: (state) => state.checkout.storeList,
      isSelfPickUp: (state) => state.checkout.isSelfPickUp,
      tenantConfig: (state) => state.home.tenantConfig,
      currentPosition: (state) => state.location.currentPosition,
      checkoutLoading: (state) => state.checkout.checkoutLoading,
      paymentConfig: (state) => state.home.paymentConfig,
    }),
    formatDate(date) {
      return new Date(date).toLocaleDateString(); // e.g., "4/7/2025"
    },
    storeAddressList() {
      let arr = [];
      if (this.storeList.length > 0) {
        this.storeList.forEach((item) => {
          const { street1, street2, area, city, state, zip } = item.address;
          let addrText = "";
          addrText += `${item.officeName}, `;
          if (street1) {
            addrText += `${street1}, `;
          }
          if (street2) {
            addrText += `${street2}, `;
          }
          if (area) {
            addrText += `${area}, `;
          }
          if (city) {
            addrText += `${city}, `;
          }
          if (state) {
            addrText += `${state}, `;
          }
          if (zip) {
            addrText += `${zip}`;
          }
          addrText += ` (${item.calculatedInKm} km)`;
          arr.push({
            value: item._id,
            text: addrText,
          });
        });
      }
      return arr;
    },
    isTodaySelected() {
      if (new Date().toISOString().split("T")[0] === this.date) {
        return true;
      } else {
        return false;
      }
    },
    timeSlots() {
      return [
        { value: null, text: "Select Time Slot" },
        {
          value: 9,
          text: "9am - 10am",
          disabled: this.isTodaySelected && new Date().getHours() >= 9,
        },
        {
          value: 10,
          text: "10am - 11am",
          disabled: this.isTodaySelected && new Date().getHours() >= 10,
        },
        {
          value: 11,
          text: "11am - 12pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 11,
        },
        {
          value: 12,
          text: "12pm - 1pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 12,
        },
        {
          value: 13,
          text: "1pm - 2pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 13,
        },
        {
          value: 14,
          text: "2pm - 3pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 14,
        },
        {
          value: 15,
          text: "3pm - 4pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 15,
        },
        {
          value: 16,
          text: "4pm - 5pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 16,
        },
        {
          value: 17,
          text: "5pm - 6pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 17,
        },
        {
          value: 18,
          text: "6pm - 7pm",
          disabled: this.isTodaySelected && new Date().getHours() >= 18,
        },
      ];
    },
    selectedAddressObj() {
      if (this.selectedAddress) {
        return this.storeList.find((item) => item._id === this.selectedAddress);
      } else return {};
    },
    minDate() {
      const today = new Date();
      const limitDate = new Date("2025-04-29");

      if (today < limitDate) {
        return "2025-04-29";
      } else {
        return today.toISOString().split("T")[0];
      }
    },
    selfPickupEnabled() {
      return this.tenantConfig?.preferences?.delivery?.isSelfpickup
        ? true
        : false;
    },
    deliveryEnabled() {
      return this.tenantConfig?.preferences?.delivery?.isGlobalDelivery
        ? true
        : false;
    },
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 2);
    return {
      min: minDate,
      max: maxDate,
      isCartVisible: false,
      isLoading: false,
      cashfreeEnv: process.env.VUE_APP_CASHFREE_ENVIRONMENT,
      stripePublicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
      stripe: null,
      loading: false,
      clientSecret: null,
      checkout: null,
      stripeDiv: null,
      selectedAddress: null,
      selfPickSelected: false,
      loadingItem: false,
      activatePaymentKey: false,
      initialiseKey: false,
      orderToken: "",
      time: "",
      date: "",
      selected: false,
      selfPickup: false,
      pickup: "",
      selectedHour: null,
      selectedTimeSlot: null,
      activeContinue: true,
      readyToPay: false,
      selectedDeliveryMode: "delivery",
      onlinePaymentLoaded: false,
    };
  },
  // 2
  created() {
    // this.$store.state["checkout"].paymentMethodClick = "COD";
    if (!this.$store.state["auth"].isLoggedin) {
      this.$router.push({ name: "login" });
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  watch: {
    // date() {
    // 	this.processForward();
    // },
    // currentPosition() {
    // 	this.getStoreList();
    // },
    paymentMethodClick() {
      // if (newVal == "STRIPE") {
      //   document.getElementById("paypal-button-container").style.display =
      //     "none";
      //   document.getElementById("checkout-container").style.display = "block";
      // }
      // if (newVal == "PAYPAL") {
      //   document.getElementById("checkout-container").style.display = "none";
      //   document.getElementById("paypal-button-container").style.display =
      //     "block";
      // }
    },
  },
  beforeDestroy() {},
  async mounted() {
    try {
      this.loadingItem = true;
      await this.fetchCart();
      await this.$store.dispatch("address/fetchDeliveryAddress");
      await this.$store.dispatch("checkout/fetchCouponList");
      // this.getStoreList();
      this.changeDeliveryMode(this.selectedDeliveryMode);
    } catch (error) {
      this.$swal({
        title: "Error",
        text: error.message,
        type: "error",
        confirmButtonText: "OK",
      });
    } finally {
      this.loadingItem = false;
    }

    //this.cashBackAccount();

    // try {
    //   if (this.cartData.length != 0) {
    //     Promise.all([
    //       // this.$store.dispatch("address/fetchDeliveryAddress"),
    //       // this.$store.dispatch(
    //       // 	"checkout/fetchPartnerInfo",
    //       // 	this.cartData[0].provider
    //       // ),
    //       // this.$store.dispatch("checkout/checkoutFinal"),
    //     ]);
    //   }
    // } catch {
    //   console.log("");
    // }
  },
  methods: {
    insertPaypalButtonContainer() {
      const container = document.getElementById("payment-div");
      if (container && !document.getElementById("paypal-button-container")) {
        const paypalDiv = document.createElement("div");
        paypalDiv.id = "paypal-button-container";
        container.appendChild(paypalDiv);
      }
    },
    removePaypalButtonContainer() {
      const paypalDiv = document.getElementById("paypal-button-container");
      if (paypalDiv) {
        paypalDiv.remove(); // or paypalDiv.parentNode.removeChild(paypalDiv);
      }
    },
    loadPayPalScript(clientId) {
      return new Promise((resolve, reject) => {
        if (document.getElementById("paypal-sdk")) {
          return resolve(); // already loaded
        }

        const script = document.createElement("script");
        script.id = "paypal-sdk";
        script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}`;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    async initiatePaypal() {
      this.onlinePaymentLoaded = false;
      if (!this?.paymentConfig?.paypal?.clientId) {
        this.$swal({
          title: "Error",
          text: "Paypal is not available now",
          type: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      await this.loadPayPalScript(this.paymentConfig.paypal.clientId);
      try {
        await this.$store.dispatch("checkout/createOrderAction");
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error.message,
          type: "error",
          confirmButtonText: "OK",
        });
      }

      this.insertPaypalButtonContainer();

      if (window.paypal) {
        window.paypal
          .Buttons({
            createOrder: () => {
              // return paypal order ID
              return this.checkoutData?.payment?.orderId;
            },
            onApprove: () => {
              // after payment approval
              this.$router.push(`/order-verify`);
            },
            onError: (err) => {
              console.error("PayPal Checkout error:", err);
              this.$swal({
                title: "Error",
                text: "Paypal is not available now",
                type: "error",
                confirmButtonText: "OK",
              });
            },
          })
          .render("#paypal-button-container");
        this.onlinePaymentLoaded = true;
      }
    },
    onPaymentMethodChange(method) {
      if (method == "STRIPE") {
        this.initiateStripe(method);
      }
      if (method == "PAYPAL") {
        this.initiatePaypal(method);
      }
    },
    async addDeliveryItem() {
      let removeItem = this.cartData.find(
        (item) => item._id === "67f0bd1458eeb6f746342b34",
      );
      if (removeItem)
        await this.$store.dispatch("checkout/removeItem", {
          cartItem: removeItem,
          callApi: true,
        });
      let totalQty = this.cartData.reduce((acc, item) => acc + item.qty, 0);
      await this.$store.dispatch("checkout/increaseCartQty", {
        cartItem: { _id: "67f0bd1458eeb6f746342b34" },
        callApi: true,
        quantity: totalQty,
      });
      await this.fetchCart();
    },
    async removeItemFromCart(data) {
      await this.$store.dispatch("checkout/removeItem", {
        cartItem: data.item,
        callApi: true,
      });
      await this.$store.dispatch("checkout/checkoutFinal");
    },
    async changeDeliveryMode(mode) {
      // this.$store.dispatch("checkout/updatePaymentClick", '');
      this.removePaypalButtonContainer();
      this.removeCheckoutContainer();
      this.onlinePaymentLoaded = false;
      if (mode == "pickup") {
        this.selfPickSelected = true;
        this.$store.commit("checkout/setPickupStatus", {
          selected: true,
        });
        // this.getStoreList();
      } else {
        this.selfPickSelected = false;
        this.$store.commit("checkout/setPickupStatus", {
          selected: false,
        });
      }
      try {
        await this.$store.dispatch("checkout/checkoutFinal");
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error.message,
          type: "error",
          confirmButtonText: "OK",
        });
      }
    },
    toggleCart() {
      this.isCartVisible = !this.isCartVisible;
    },
    changeAddress(addr) {
      let storeAddress = this.storeList.find((item) => item._id === addr);
      if (storeAddress) {
        this.$store.dispatch("checkout/updateSelectedStore", {
          ...storeAddress,
        });
      }
    },
    addCheckoutContainer() {
      const parent = document.getElementById("payment-div");
      if (parent && !document.getElementById("checkout-container")) {
        const checkoutDiv = document.createElement("div");
        checkoutDiv.id = "checkout-container";
        parent.appendChild(checkoutDiv);
      }
    },
    removeCheckoutContainer() {
      const checkoutDiv = document.getElementById("checkout-container");
      if (checkoutDiv) {
        checkoutDiv.remove(); // or checkoutDiv.parentNode.removeChild(checkoutDiv);
      }
    },
    async initiateStripe(method) {
      this.onlinePaymentLoaded = false;
      this.addCheckoutContainer();
      this.stripeDiv = document.getElementById("checkout-container");
      if (this.checkout) {
        this.checkout.unmount();
        this.checkout.destroy();
        this.checkout = null;
      }
      // 🚫 Exit if not Stripe method
      if (method !== "STRIPE") return;

      this.$store.state["checkout"].checkoutLoading = true;

      try {
        // 🧾 4. Create order
        await this.$store.dispatch("checkout/createOrderAction");

        // 💳 5. Load Stripe if not already available
        if (!this.stripe && this.paymentConfig?.stripe?.publicKey) {
          this.stripe = await loadStripe(this.paymentConfig.stripe.publicKey);
        }

        if (!this.stripe) {
          this.$swal({
            title: this.$t("swal.error"),
            text: this.$t("swal.stripeUnavailable"),
            type: "error",
            confirmButtonText: "OK",
          });
          return;
        }

        // 🎟️ 6. Fetch client secret if missing
        // if (!this.clientSecret) {
        // 	const sessionRes = await this.$store.dispatch(
        // 		"checkout/fetchStripeCheckoutInfo",
        // 		{
        // 			tenant: process.env.VUE_APP_TENANT,
        // 			customer: { id: this.userInfo._id },
        // 			platform: "web",
        // 			currency: "USD",
        // 			productName: this.checkoutData.items[0].name,
        // 			amount: this.checkoutData.totalPrice * 1 * 10,
        // 			qty: "1",
        // 			redirect_on_completion: "always",
        // 			returnUrl: "http://localhost:8080/#/order-verify",
        // 			// returnUrl: "https://indianmangoes.com/#/order-verify",
        // 		}
        // 	);

        // 	this.clientSecret = sessionRes.data?.res?.client_secret;
        // }

        // ✅ 7. Mount Embedded Checkout
        this.mountStripe();
      } catch (error) {
        this.$swal({
          title: this.$t("swal.error"),
          text: error.message || this.$t("cart.checkoutError"),
          type: "error",
          confirmButtonText: "OK",
        });
      } finally {
        this.$store.state["checkout"].checkoutLoading = false;
      }
    },
    async mountStripe() {
      try {
        if (this.checkoutData?.payment?.pgOrderData.client_secret) {
          this.checkout = await this.stripe.initEmbeddedCheckout({
            clientSecret: this.checkoutData?.payment?.pgOrderData.client_secret,
          });
          this.checkout.mount("#checkout-container");

          // 🎯 8. Smooth scroll into view
          setTimeout(() => {
            this.stripeDiv.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 300);
          this.onlinePaymentLoaded = true;
        } else {
          this.$swal({
            title: this.$t("swal.error"),
            text: this.$t("swal.stripeUnavailable"),
            type: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: this.$t("swal.stripeUnavailable"),
          type: "error",
          confirmButtonText: "OK",
        });
      }
    },
    async onClickCheckbox() {
      if (this.selected) {
        this.selfPickSelected = true;
      }
      this.$store.commit("checkout/setPickupStatus", {
        selected: this.selected,
      });
      await this.$store.dispatch("checkout/checkoutFinal");
    },
    processForward() {
      this.setTime();
      this.readyToPay = true;
    },
    returnToCheckout() {
      this.activatePaymentKey = false;
      this.$store.dispatch("checkout/updatePaymentClick", "");
    },
    toCheckout() {
      this.activatePaymentKey = false;
      this.$store.dispatch("checkout/updatePaymentClick", "");
      if (this.checkout) {
        this.checkout.unmount();
        this.checkout.destroy();
        this.checkout = null;
      }
    },
    changeDate(value) {
      if (
        value == new Date().toISOString().split("T")[0] &&
        new Date().getHours() >= this.selectedTimeSlot
      )
        this.selectedTimeSlot = null;
      this.setTime();
    },
    convertToISO(hour = 9) {
      const date = new Date(Date.UTC(1970, 0, 1, hour, 0, 0, 0)); // UTC time
      return date.toISOString().split("T")[1]; // Extract only the time part
    },
    async setTime() {
      this.pickup = `${
        this.date || new Date().toISOString().split("T")[0]
      }T${this.convertToISO(this.selectedTimeSlot)}`;
      this.$store.commit("checkout/setPickupStatus", {
        pickup: this.pickup,
        selected: this.selfPickSelected,
      });
      await this.$store.dispatch("checkout/checkoutFinal");
      this.readyToPay = true;
    },
    onFailure(err) {
      console.log(err);
      this.$swal({
        group: "item",
        title: this.$t("swal.paymentRefund"),
        text: "",
        type: "error",
      });
      this.$router.push({ path: "/" });
    },
    // async cashBackAccount() {
    //   try {
    //     await this.$store
    //       .dispatch("checkout/getAccountDetails", this.userInfo._id)
    //       .then((res) => {
    //         if (res.data.data.status === "SUCCESS") {
    //           console.log(res);
    //         }
    //       });
    //   } catch (e) {
    //     document.getElementById("cashback").innerText =
    //       "To receive cashbacks please add your bank details under cashback accounts.";
    //   }
    // },
    onSuccess(res) {
      console.log(res);
      this.placeOrderFinal();
    },
    async clearCart() {
      await this.$store.dispatch("checkout/clearCart");
    },
    onPaymentSelect(val) {
      this.onlinePaymentLoaded = false;
      if (val === "COD") {
        this.removePaypalButtonContainer();
        this.removeCheckoutContainer();
      }
    },
    async placeOrderInit() {
      if (!this.paymentMethodClick) {
        this.$swal({
          title: this.$t("swal.error"),
          text: this.$t("cart.selectPaymentMethod"),
          type: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      if (this.selfPickSelected) {
        if (this.date == "" && this.selectedTimeSlot == null) {
          this.showCustomToast(this.$t("cart.missedDateTime"));
          return;
        }
        // if (this.date == "" && this.selectedAddress == null) {
        // 	this.showCustomToast(this.$t("cart.missedDateStore"));
        // 	return;
        // }
        // if (this.selectedTimeSlot == null && this.selectedAddress == null) {
        // 	this.showCustomToast(this.$t("cart.missedTimeStore"));
        // 	return;
        // }
        if (this.date == "") {
          this.showCustomToast(this.$t("cart.missedDate"));
          return;
        }
        if (this.selectedTimeSlot == null) {
          this.showCustomToast(this.$t("cart.missedTime"));
          return;
        }
        // if (this.selectedAddress == null) {
        // 	this.showCustomToast(this.$t("cart.missedStore"));
        // 	return;
        // }
      }
      if (this.paymentMethodClick == "COD") {
        this.createOrder();
        return;
      }
      if (
        this.paymentMethodClick == "STRIPE" ||
        this.paymentMethodClick == "PAYPAL"
      ) {
        this.onPaymentMethodChange(this.paymentMethodClick);
        return;
      }
      // 1
      if (this.paymentMethodClick == "CASHFREE") {
        this.$store.state["checkout"].checkoutLoading = true;
        await this.$store
          .dispatch("checkout/createOrderAction")
          .then(async (res) => {
            if (res.status === 200) {
              this.initiateCashfree();
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$t("swal.orderFailed"),
              });
              // this.$router.push({ path: "/" });
              await this.$store.dispatch("checkout/checkoutFinal");
            }
          })
          .catch((err) => {
            console.log(err, "");
          });
      }
    },
    async initiateCashfree() {
      if (this.checkoutData?.payment?.signatureWeb) {
        this.orderToken = this.checkoutData?.payment?.signatureWeb;
        this.initialiseKey = false;
        setTimeout(() => {
          this.initialiseKey = true;
        }, 1);
      } else {
        this.initialiseKey = false;
      }
    },
    async createOrder() {
      this.$store.state["checkout"].checkoutLoading = true;
      try {
        let res = await this.$store.dispatch("checkout/createOrderAction");
        await this.$store.dispatch("checkout/clearCart");
        this.$router.push({
          name: "order-success",
          params: {
            orderId: res.data?.response?.orderId,
          },
        });
      } catch (error) {
        await this.$store.dispatch("checkout/checkoutFinal");
        this.$swal({
          title: "Error",
          text: error.message,
          type: "error",
          confirmButtonText: "OK",
        });
      } finally {
        this.$store.state["checkout"].checkoutLoading = false;
      }
    },
    async getStoreList() {
      // let coords = this.defaultAddress?.location?.coordinates || [];
      // if (!coords.length && this.currentPosition) {
      // 	coords = [this.currentPosition.Lat, this.currentPosition.Lng];
      // } else {
      // 	this.$toasted.info("please select your location");
      // 	return;
      // }
      if (!this.cartData.length) return;
      try {
        await this.$store.dispatch("checkout/fetchStoreList", {
          parent: this.cartData[0].provider,
          category: "OFFICE",
          lat: 30.267153,
          lng: -97.7430608,
          radius: 6000,
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error.message,
          type: "error",
          confirmButtonText: "OK",
        });
      }
    },
    async placeOrderFinal() {
      let payload = {
        customerDetails: {
          orderAmount: this.checkoutData.totalPrice,
          customerName: this.userInfo.authentication.userName,
          customerPhone: this.userInfo.authentication.phone,
          customerEmail: this.userInfo.authentication.email,
        },
        orderDetails: {
          paymentType: this.checkoutData.payment.type,
          deliveryAddress: {
            address: this.defaultAddress,
            loc: this.defaultAddress.location,
          },
          items: this.checkoutData.items ? this.checkoutData.items : [],
        },
        createdAt: this.checkoutData.createdAt,
        payments: this.checkoutData.payments,
        payment: this.checkoutData.payment,
        orderHash: this.checkoutData.hash,
        totalPriceBeforeTax: this.checkoutData.totalPriceBeforeTax,
        orderId: this.createdOrderData?.orderId,
      };
      await this.$store
        .dispatch("checkout/validateOrderAction", payload)
        .then(async (res) => {
          this.$store.state["checkout"].checkoutLoading = false;
          this.$router.push({
            name: "order-success",
            params: {
              orderId: res.data?.response?.orderId,
            },
          });
        })
        .catch((err) => {
          this.$store.state["checkout"].checkoutLoading = false;
          console.log("err", err);
        });
    },
    showCustomToast(msg = this.$t("cart.missedDateTimeStore")) {
      this.$swal({
        title: "",
        text: msg,
        type: "info",
        confirmButtonText: "OK",
      });
    },
    navigateToGoogleMap(value) {
      let storeAddress = this.storeList.find((item) => item._id === value);

      // const startCoord = this.defaultAddress.location.coordinates;
      // const start = `${startCoord[0]},${startCoord[1]}`;

      // if (!this.currentPosition) {
      // 	this.$toasted.info("please select your location");
      // 	return;
      // }

      // const start = `${this.currentPosition.Lat},${this.currentPosition.Lng}`; // San Francisco

      const destCoord = storeAddress.address.location.coordinates;
      const destination = `${destCoord[1]},${destCoord[0]}`; // San Francisco
      // const url = `https://www.google.com/maps/dir/?api=1&origin=${start}&destination=${destination}`;
      // window.open(url, "_blank");

      const url = `https://www.google.com/maps?q=${destination}`;
      window.open(url, "_blank");
    },
    async changeTimeSlot(time) {
      this.setTime();
      let obj = this.timeSlots.find((item) => item.value === time);
      if (obj) {
        await this.$store.dispatch("checkout/updateTimeSlot", obj);
      }
    },
    continuePayment() {
      if (this.selfPickSelected) {
        // if (
        // 	this.date == "" &&
        // 	this.selectedTimeSlot == null &&
        // 	this.selectedAddress == null
        // ) {
        // 	this.showCustomToast(this.$t("cart.missedDateTimeStore"));
        // 	return;
        // }
        if (this.date == "" && this.selectedTimeSlot == null) {
          this.showCustomToast(this.$t("cart.missedDateTime"));
          return;
        }
        // if (this.date == "" && this.selectedAddress == null) {
        // 	this.showCustomToast(this.$t("cart.missedDateStore"));
        // 	return;
        // }
        // if (this.selectedTimeSlot == null && this.selectedAddress == null) {
        // 	this.showCustomToast(this.$t("cart.missedTimeStore"));
        // 	return;
        // }
        if (this.date == "") {
          this.showCustomToast(this.$t("cart.missedDate"));
          return;
        }
        if (this.selectedTimeSlot == null) {
          this.showCustomToast(this.$t("cart.missedTime"));
          return;
        }
        // if (this.selectedAddress == null) {
        // 	this.showCustomToast(this.$t("cart.missedStore"));
        // 	return;
        // }
        this.activatePaymentKey = true;
      } else {
        this.activatePaymentKey = true;
      }
      if (this.checkout) {
        this.checkout.unmount();
        this.checkout.destroy();
        this.checkout = null;
      }
    },
    async fetchCart() {
      await this.$store.dispatch("checkout/fetchCartData", {
        shipFrom: "US",
        shipTo: "US",
        country: "US",
      });
    },
  },
};
</script>
<style scoped>
.checkout {
  padding-top: 15px;
  margin-bottom: 15px;
}

.self-pickup {
  font-style: normal;
  padding: 16px;
  margin-top: 10px;
  width: 300px;
  margin-left: 10px;
  color: hsl(0, 6%, 3%);
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
}

.color-transaction {
  background: linear-gradient(#ff1934, #ff4d35, #ff7f37);
}

.button-color {
  background-color: var(--primarycolor);
}

::v-deep #date-time__dialog_ {
  z-index: 1;
}

.text {
  font-style: normal;
  color: rgb(240, 60, 60);
  padding: 18px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.btn-outline-primary {
  width: 180px;
  height: 45px;
}

.btn-primary {
  width: 180px;
  height: 45px;
  border-radius: 3px;
}

.btn-outline-primary:hover {
  width: 180px;
  height: 45px;
}

.button-text {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-transform: capitalize;
  color: var(--primarycolor);
}

.button-text :hover {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-transform: capitalize;
  color: #fff;
}

.checkout-empty {
  margin-top: 35px;
}
.direct-class {
  cursor: pointer;
}
.store-box {
  padding: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-top: 12px;
}
.place-order-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
}
@media (max-width: 768px) {
  .place-order-btn-box {
    flex-direction: column;
  }
  .store-select {
    flex-wrap: wrap;
    gap: 5px;
  }
}
@media (min-width: 769px) and (max-width: 1669px) {
  .store-select h4 .b-icon.bi {
    margin-top: 8px;
  }
}
@media (max-width: 1200px) {
  ::v-deep .dropdown-menu.show {
    transform: translate3d(0px, 30px, 0px) !important;
  }
}
h6,
h5,
h4 {
  font-size: 15px;
  font-weight: 600;
  margin-top: 2px;
}

.store-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
